import React from 'react';
import styled from 'styled-components';

export const ShipmentsLayout = styled.div`
  display: flex;
  align-items: stretch;
  grid-gap: 16px;
  width: 100%;
  min-height: 0;

  .shipments-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }
`;

const PanelWrapper = styled.aside`
  flex-shrink: 0;
  width: 380px;
  background: #FFFFFF;
  border: 1px solid #ECEFF1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* Stretched to match the items table's height by ShipmentsLayout's align-items:stretch —
     min-height:0 lets .panel-rows below actually shrink and scroll instead of growing past it. */
  min-height: 0;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    border-bottom: 1px solid #ECEFF1;
    flex-shrink: 0;
    h2 {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: #16181D;
      span {
        color: #808183;
        font-weight: 500;
      }
    }
    .panel-hint {
      font-size: 11px;
      color: #808183;
    }
  }

  .panel-rows {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    padding: 8px;
    grid-row-gap: 4px;
    overflow-y: auto;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #B8C4CB;
      border-radius: 3px;
    }
  }

  .location-row {
    display: grid;
    grid-template-columns: 96px 1fr 90px;
    align-items: center;
    grid-column-gap: 12px;
    padding: 10px 12px;
    border-radius: 6px;
    border: 1px solid transparent;
    &.clickable {
      cursor: pointer;
    }
    &.active {
      background: #F3F6FE;
      border-color: #1565D8;
    }
    .location-id {
      display: flex;
      flex-direction: column;
      grid-row-gap: 2px;
      min-width: 0;
      .id-value {
        font-size: 13px;
        font-weight: 600;
        color: #16181D;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .id-sub {
        font-size: 11px;
        color: #808183;
      }
    }
    .location-units {
      font-size: 12px;
      font-weight: 600;
      color: #16181D;
      min-width: 0;
    }
    .location-miles {
      .miles-value {
        font-size: 12px;
        font-weight: 600;
        color: #16181D;
        white-space: nowrap;
      }
    }
  }
`;

// White bordered card listing shipment destinations, scrollable within its own row area.
// rows: [{ key, active, onClick, id, subLabel, units, milesLabel }]
const ShipmentLocationsPanel = ({ title = 'Destinations', hint, rows = [] }) => (
  <PanelWrapper className="shipment-locations-panel">
    <div className="panel-header">
      <h2>{title} <span>({rows.length})</span></h2>
      {hint && <span className="panel-hint">{hint}</span>}
    </div>
    <div className="panel-rows">
      {rows.map(({ key, active, onClick, id, subLabel, units, milesLabel }) => (
        <div
          key={key}
          className={`location-row ${active ? 'active' : ''} ${onClick ? 'clickable' : ''}`}
          onClick={onClick}
        >
          <div className="location-id">
            <span className="id-value">{id}</span>
            {subLabel && <span className="id-sub">{subLabel}</span>}
          </div>
          <span className="location-units">{units} units</span>
          <div className="location-miles">
            <span className="miles-value">{milesLabel}</span>
          </div>
        </div>
      ))}
    </div>
  </PanelWrapper>
);

export default ShipmentLocationsPanel;
